const t = "已完成的步骤", o = "返回到{buttonName}", e = "继续到 {buttonName}", n = {
  completedStep: t,
  backButton: o,
  nextButton: e
};
export {
  o as backButton,
  t as completedStep,
  n as default,
  e as nextButton
};
